<template lang="html">

  <footer class="footer row-between">

    <div class="logos-pie row-start">
      <a href="https://fgulem.unileon.es/fgulem/" target="_blank"><img src="/static/img/logos-fgulem-ule-negativo.png" width="270px"></a>
    </div>

    
    <nav class="column-center">
      <a target="_blank" href="https://fgulem.unileon.es/fgulem/aviso.aspx">Aviso legal</a>
      <a target="_blank" href="https://fgulem.unileon.es/fgulem/privacidad.aspx">Política de privacidad</a>
      <a target="_blank" href="">Política de Cookies</a>
      <p>Copyright © 2023 - Fundación General de la Universidad de León y de la Empresa</p>
    </nav>

  </footer>

</template>

<script lang="js">
  export default {
    name: 'app-footer',
  }
</script>

<style scoped>
  .footer {}
</style>


// WEBPACK FOOTER //
// src/components/parts/footer.vue